import { useOutletContext } from 'react-router-dom'

import { EmployeeForSelectFragmentNoAccess } from 'modules/core/components/EntitySelectWrapper/Entities/Employees/types'
import Chip from 'modules/core/components/Filter/base/Chip'
import Content from 'modules/core/components/Filter/base/Content'
import Provider from 'modules/core/components/Filter/base/Provider'
import { getEmployeeDisplayName } from 'modules/core/lib/employeeName'
import i18n from 'modules/core/lib/i18n'

import { EmployeeSelector } from 'modules/employees/components/EmployeeSelector'
import { ReviewOverviewOutletContext } from 'modules/performance_process/pages/reviews/show/overview'

import { isManagerFilterVisible, useFilter } from '../context'

export const ManagerFilter = () => {
  const { reviewProcess } = useOutletContext<ReviewOverviewOutletContext>()
  const { value, setValue } = useFilter('manager')
  const { setValue: setOnlyDirectReports } = useFilter('onlyDirectReports')

  if (!isManagerFilterVisible(reviewProcess)) {
    return null
  }

  const onSelect = (v: EmployeeForSelectFragmentNoAccess | null) => {
    setValue(v)
    setOnlyDirectReports(true)
  }

  return (
    <EmployeeSelector
      hideBorder
      multiple={false}
      value={value}
      employeeIds={reviewProcess.targetManager.map((manager) => Number(manager.id))}
      onSelect={onSelect}
    >
      <Provider value={value} onValueChange={() => null} defaultOpen={false} closeOnChange>
        <Chip.Toggler
          active={!!value}
          label={i18n.t('common.manager')}
          activeLabel={
            value
              ? getEmployeeDisplayName({
                  fullName: value.fullName,
                  lastName: value.lastName,
                  preferredName: value.preferredName,
                })
              : ''
          }
        />
        <Content maxWidth="s" maxHeight="s600" />
      </Provider>
    </EmployeeSelector>
  )
}
